var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3257)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.75 35H36.775L36.075 34.325C38.525 31.475 40 27.775 40 23.75C40 14.775 32.725 7.5 23.75 7.5C14.775 7.5 7.5 14.775 7.5 23.75C7.5 32.725 14.775 40 23.75 40C27.775 40 31.475 38.525 34.325 36.075L35 36.775V38.75L47.5 51.225L51.225 47.5L38.75 35ZM23.75 35C17.525 35 12.5 29.975 12.5 23.75C12.5 17.525 17.525 12.5 23.75 12.5C29.975 12.5 35 17.525 35 23.75C35 29.975 29.975 35 23.75 35Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3257"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.ab40ef26972f1679423c318ff96cd6e5.svg";
export { ForwardRef as ReactComponent };